class Player {
  constructor(name, isHuman, color) {
    this.name = name;
    this.score = 0;
    this.isHuman = isHuman;
    this.color = color;
  }
}

export default Player;
